export default __webpack_public_path__ + "pgnv-assets/2dc79a6d508d391a032b1557e586e70a.svg";